import { render } from "./ListePersonnel.vue?vue&type=template&id=224112d6&ts=true"
import script from "./ListePersonnel.vue?vue&type=script&lang=ts"
export * from "./ListePersonnel.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__